import { ThumborDefaults, thumborLink, ThumborOptions } from './thumbor'
import React from 'react'
import styled from '@emotion/styled'
import { css, SerializedStyles } from '@emotion/react'

import { SizeMods } from 'components/styles/primitives/modifiers/size'
import { Modifiable, Mods } from 'components/styles/primitives/core/mods'
import { ensureArray } from '../types/arrays'

interface Props extends Mods {
	src: string
	alt?: string
	backgroundColor?: string
	/**
	 * @deprecated Use Mods
	 */
	styles?: SerializedStyles
	options?: ThumborOptions
}

/**
 *
 * @deprecated
 * Use new ThumborImg from /ThumborImg folder
 * Here until we get rid of emotion.
 */
export const ThumborImg: React.FC<React.PropsWithChildren<Props>> = ({
	styles = css(),
	modifiers = css(),
	src,
	options,
	alt,
	backgroundColor = 'white'
}) => {
	if (src.endsWith('.svg')) return <Image modifiers={[styles, ...ensureArray(modifiers)]} src={src} alt={alt} />

	const webpLink = thumborLink(src, { ...ThumborDefaults, ...options, filters: { format: 'webp', backgroundColor } })
	const jpegLink = thumborLink(src, { ...ThumborDefaults, ...options, filters: { format: 'jpeg', backgroundColor } })
	return (
		<picture>
			<source type="image/webp" srcSet={webpLink} />
			<source type="image/jpeg" srcSet={jpegLink} />
			<Image modifiers={[styles, ...ensureArray(modifiers)]} src={jpegLink} alt={alt} />
		</picture>
	)
}

const Image = styled.img<Mods>`
	${SizeMods.Constrained}
	${Modifiable}
`
